import { PRE_EMPLOYMENT_STORAGE_KEY } from '../steps/preEmployment/PreEmploymentTypes';

interface PreEmploymentLookup {
  firstName: string;
  lastName: string;
  middleInitial: string;
  ssn: string;
  dob: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  county: string;
  fullName: string;
}

const safeString = (v: any): string => (v == null ? '' : String(v));

const parseApplicationJson = (raw: any): { formData?: any } => {
  if (!raw) return {};
  try {
    if (typeof raw === 'string') return JSON.parse(raw);
    return raw;
  } catch {
    return {};
  }
};

const buildLookup = (formData: any): PreEmploymentLookup => {
  const firstName = safeString(formData?.legalFirstName);
  const lastName = safeString(formData?.legalLastName);
  return {
    firstName,
    lastName,
    middleInitial: '',
    ssn: safeString(formData?.ssn),
    dob: safeString(formData?.dob),
    email: safeString(formData?.email),
    phone: safeString(formData?.phoneNumber),
    address: safeString(formData?.address),
    city: safeString(formData?.city),
    state: safeString(formData?.state),
    zipCode: safeString(formData?.zipCode),
    county: safeString(formData?.county),
    fullName: [firstName, lastName].filter(Boolean).join(' '),
  };
};

const empty: PreEmploymentLookup = {
  firstName: '',
  lastName: '',
  middleInitial: '',
  ssn: '',
  dob: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  zipCode: '',
  county: '',
  fullName: '',
};

const readLocalStorageFormData = (token?: string): any => {
  if (!token) return null;
  try {
    const raw = localStorage.getItem(PRE_EMPLOYMENT_STORAGE_KEY(token));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getPreEmploymentLookup = (
  application: any,
  applicationDraft: any,
  token?: string,
): PreEmploymentLookup => {
  const local = readLocalStorageFormData(token);
  if (local && (local.legalFirstName || local.legalLastName)) return buildLookup(local);
  const finalized = parseApplicationJson(application?.json);
  if (finalized.formData) return buildLookup(finalized.formData);
  const draft = parseApplicationJson(applicationDraft?.json);
  if (draft.formData) return buildLookup(draft.formData);
  return empty;
};

export type { PreEmploymentLookup };
